package com.appsyde.shared.modules.ticket.domain.model

import kotlinx.datetime.Instant

data class AssignedTo(
    val accountUserId: String,
    val displayName: String
)

data class WriteLock(
    val accountUserId: String,
    val displayName: String,
    val expiresAt: Instant
)

data class WriteLockDetail(
    val accountUserId: String,
    val displayName: String,
    val expiresAt: Instant
)

data class Ticket(
    val ticketId: String,
    val providerThreadId: String,
    val status: String,
    val needsResponse: Boolean,
    val isRead: Boolean = true,

    val stateSummary: String?,
    val respondContext: String?,

    val detectedMemoryJson: String?,
    val missingKeysJson: String,
    val toConfirmKeysJson: String,

    val currentIntent: String?,
    val currentPriority: String?,
    val currentComplexity: String?,
    val currentSuggestedActionCode: String?,
    val currentSuggestedActionLabel: String?,
    val currentSuggestedActionWhy: String? = null,

    val detectedSourcesJson: String? = null,

    val currentDraftSuggestion: String? = null,
    val currentDraftSuggestionUpdatedAtMs: Long? = null,
    val currentDraftSourceMessageId: String? = null,

    val clientEmail: String? = null,
    val subject: String? = null,
    val updatedAtMs: Long,
    val lastInboundSentAtMs: Long? = null,
    val lastOutboundSentAtMs: Long? = null,

    val lastInboundMessageId: String?,

    val extractStatus: String? = null,
    val extractJson: String? = null,

    val historyMeta: HistoryMeta? = null,

    val assignedTo: AssignedTo? = null,
    val writeLock: WriteLock? = null
)
